const initMobMenuBtn = () => {
    const navMenu = document.querySelector('.js-nav-menu');
    const navBtns = document.querySelectorAll('.js-nav-btn');

    navBtns.forEach(navBtn => {
        navBtn.addEventListener('click', () => {
            navMenu.classList.toggle('active');
        })
    });
}

initMobMenuBtn()
